/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import { addNewAnimationElement, addNewVoiceElement, defaultPosition, defaultRotation } from './libs/util'

function buildButtonComponent (componentName) {
  return new UI.Button(componentName)
    .setWidth('72%')
    .setPadding('10px 0')
    .setBorderRadius('8px')
    .setBackgroundColor('#121212')
}

var SettingsTab = function (editor) {
  var signals = editor.signals

  var container = new UI.Panel()
  container.setId('settingsTab')

  var selected = null

  function build () {
    container.clear()
    if (selected === null) {
      return
    }

    if (!selected.elements.length) {
      addNewAnimationElement(editor, selected)
      addNewVoiceElement(editor, selected)
    }

    // Time
    var time = new UI.Row()
    time.add(new UI.Text('Time').setWidth('45px'))

    var animationStart = new UI.Number(selected.start).setWidth('45px')
    animationStart.onChange(function () {
      selected.start = this.getValue()
      signals.animationModified.dispatch(selected)
    })
    time.add(animationStart)

    var animationEnd = new UI.Number(selected.end).setWidth('45px')
    animationEnd.onChange(function () {
      selected.end = this.getValue()
      signals.animationModified.dispatch(selected)
    })
    time.add(animationEnd)
    container.add(time)

    // Name
    var name = new UI.Row()
    name.add(new UI.Text('Name').setWidth('180px'))

    var nameInput = new UI.Input(selected.name)
    nameInput.onChange(function () {
      let val = this.getValue()
      selected.name = val
      signals.animationModified.dispatch(selected)
    })
    name.add(nameInput)
    container.add(name)

    // Position of origin
    var originalPos = new UI.Row()
    originalPos.add(new UI.Text('Position of Origin').setWidth('180px'))

    var [originalPosX, originalPosY, originalPosZ] = selected.origin.position

    var originalPosInput = new UI.Input(`(${originalPosX}, ${originalPosY}, ${originalPosZ})`)
    originalPosInput.onChange(function () {
      // record its position before change, used for calculating the different
      // let originalPosition = [...selected.origin.position]
      let val = this.getValue().substring(1, this.getValue().length - 1)
      let position = val.split(',').map(s => parseFloat(s.trim()))

      // prevent model position from going below floor
      if (position[1] < 0) {
        position[1] = 0
      }

      // fetch the number of the input
      selected.origin.position[0] = position[0]
      selected.origin.position[1] = position[1]
      selected.origin.position[2] = position[2]

      // calculating the difference, if [3,3,3] -> [1,1,1], then tempDiffArray = [2,2,2]
      // let tempDiffArray = selected.origin.position.map((digit, idx) => {
      //   digit = digit - originalPosition[idx]
      //   return digit
      // })

      // fetch all the animations of this character
      let animations = selected.elements.filter(ele => ele.animation)

      // let tempDiffArray apply to all the animations position
      // tempAnimations is the array of animations that are after dynamically changing the position
      let tempAnimations = animations.map(animation => {
        let changedPosition = animation.animation.destination.position.map((digit, idx) => {
          digit = selected.origin.position[idx]
          return digit
        })
        animation.animation.destination.position = changedPosition
        return animation
      })
      // assign the animations with tempAnimations, since animations is copied by reference, they will change in their own info of panel
      animations = tempAnimations
      signals.animationModified.dispatch(selected)
    })
    originalPos.add(originalPosInput)
    container.add(originalPos)

    // Reset Position of origin
    var resetOriginalPos = new UI.Row()
    var resetOriginalPosButton = buildButtonComponent('Reset Position')
    resetOriginalPosButton.onClick(function () {
      selected.origin.position[0] = defaultPosition[0]
      selected.origin.position[1] = defaultPosition[1]
      selected.origin.position[2] = defaultPosition[2]
      signals.animationModified.dispatch(selected)
    })
    resetOriginalPos.add(resetOriginalPosButton)
    container.add(resetOriginalPos)

    // Rotation of origin
    var originalRot = new UI.Row()
    originalRot.add(new UI.Text('Rotation of origin').setWidth('180px'))

    var [originalRotX, originalRotY, originalRotZ] = selected.origin.rotation

    var originalRotInput = new UI.Input(`(${originalRotX}, ${originalRotY}, ${originalRotZ})`)
    originalRotInput.onChange(function () {
      let val = this.getValue().substring(1, this.getValue().length - 1)
      let rotation = val.split(',').map(s => parseFloat(s.trim()))
      selected.origin.rotation[0] = rotation[0]
      selected.origin.rotation[1] = rotation[1]
      selected.origin.rotation[2] = rotation[2]
      signals.animationModified.dispatch(selected)
    })
    originalRot.add(originalRotInput)
    container.add(originalRot)

    // Reset Rotation of origin
    var resetOriginalRot = new UI.Row()
    var resetOriginalRotButton = buildButtonComponent('Reset Rotation')
    resetOriginalRotButton.onClick(function () {
      selected.origin.rotation[0] = defaultRotation[0]
      selected.origin.rotation[1] = defaultRotation[1]
      selected.origin.rotation[2] = defaultRotation[2]
      signals.animationModified.dispatch(selected)
    })
    resetOriginalRot.add(resetOriginalRotButton)
    container.add(resetOriginalRot)
  }

  // signals.editorCleared.add( function () {
  //   selected = null
  //   build();
  // })

  signals.animationSelected.add(function (animation) {
    // this is a bandaid -dj
    if (animation && animation.type === 'Character') {
      selected = animation
      build()
    }
  })

  signals.animationModified.add(function (animation) {
    if (animation && animation.type === 'Character') {
      selected = animation
      build()
    }
  })

  signals.transferPostionToAnimation.add(function (newPosition) {
    if (selected !== null) {
      let animations = selected.elements.filter(ele => ele.animation)
      let tempAnimations = animations.map((animation) => {
        let changedPosition = animation.animation.destination.position.map((digit, idx) => {
          digit = newPosition[idx]
          return digit
        })
        animation.animation.destination.position = changedPosition
        return animation
      })
    // assign the animations with tempAnimations, since animations is copied by reference, they will change in their own info of panel
      animations = tempAnimations
    }
  })

  signals.effectCompiled.add(build)

  // signals.timeChanged.add(function () {
  //   if (selected !== null) {
  //     for (var key in values) {
  //       values[key].setValue(selected.module.parameters[ key ].value)
  //     }
  //   }
  // })

  return container
}

export default SettingsTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/SettingsTab.js
// module id = null
// module chunks = 